export const commonSteper_style = {};
